import { SummaryTextContent as Container } from './styles'

export function SummaryTextContent({ children }) {
  return <Container>{children}</Container>
}
